const throttle = function() {
    let isClear = arguments[0],
        fn,
        param;
    
    // 第一个参数是布尔值
    if (typeof isClear === 'boolean') {
        fn = arguments[1];
        // fn存在定时句柄，则清除
        fn.__throttleID && clearTimeout(fn.__throttleID);
    } else {
        // fn取第一个参数
        fn = isClear;
        // 第二个参数为fn参数
        param = arguments[1];
        // 设置默认项
        param = Object.assign({
            context: null,
            args: [],
            time: 300,
        }, param);
        // 清除定时句柄
        throttle(true, fn);
        // 设置定时句柄
        fn.__throttleID = setTimeout(() => {
            fn.apply(param.context, param.args);
        }, param.time);
    }
};

export default throttle;


// WEBPACK FOOTER //
// ./src/components/shared/throttle.js